import apiClient from '../config/api';
import { Projet, ProjetRequestDTO } from '../types';

class ProjetService {
  /**
   * Récupérer tous les projets
   */
  async getAll(): Promise<Projet[]> {
    const response = await apiClient.get<Projet[]>('/api/projets');
    return response.data;
  }

  /**
   * Récupérer un projet par son ID
   */
  async getById(id: number): Promise<Projet> {
    const response = await apiClient.get<Projet>(`/api/projets/${id}`);
    return response.data;
  }

  /**
   * Créer un nouveau projet
   */
  async create(data: ProjetRequestDTO): Promise<Projet> {
    const response = await apiClient.post<Projet>('/api/projets', data);
    return response.data;
  }

  /**
   * Mettre à jour un projet
   */
  async update(id: number, data: Partial<ProjetRequestDTO>): Promise<Projet> {
    const response = await apiClient.put<Projet>(`/api/projets/${id}`, data);
    return response.data;
  }

  /**
   * Supprimer un projet
   */
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/projets/${id}`);
  }

  /**
   * Récupérer les projets d'un client
   */
  async getByClientId(clientId: number): Promise<Projet[]> {
    const response = await apiClient.get<Projet[]>(`/api/projets/client/${clientId}`);
    return response.data;
  }

  /**
   * Mettre à jour le statut d'un projet
   */
  async updateStatus(id: number, statut: string): Promise<Projet> {
    const response = await apiClient.patch<Projet>(`/api/projets/${id}/statut`, { statut });
    return response.data;
  }
}

export default new ProjetService();
